module.exports = __webpack_public_path__ + "static/media/room-13.c414278a.jpg";